import { useSearchParams, Link } from "react-router-dom";
import MenuSheet from "@/components/MenuSheet";
import SundayResetCard from "@/components/SundayResetCard";
import PremiumGate from "@/components/PremiumGate";
import { Button } from "@/components/ui/button";
import { ArrowLeft, History as HistoryIcon } from "lucide-react";
import { getISOWeekKey } from "@/lib/week";

export default function SundayResetPage() {
  const [params] = useSearchParams();
  const weekKey = params.get("week") || getISOWeekKey(new Date());

  return (
    <div className="min-h-screen">
      <div className="max-w-3xl mx-auto p-4 sm:p-6 lg:p-8 space-y-5">
        <div className="flex items-center gap-2 flex-wrap">
          <MenuSheet />
          <Button variant="ghost" size="sm" asChild className="rounded-xl" data-testid="sunday-reset-back">
            <Link to="/">
              <ArrowLeft strokeWidth={1.5} className="size-4 mr-1.5" />
              Back to planner
            </Link>
          </Button>
          <div className="ml-auto">
            <Button variant="outline" size="sm" asChild className="rounded-xl" data-testid="sunday-reset-history-button">
              <Link to="/sunday-reset/history">
                <HistoryIcon strokeWidth={1.5} className="size-4 mr-1.5" />
                History
              </Link>
            </Button>
          </div>
        </div>
        <PremiumGate feature="Sunday Reset">
          <SundayResetCard weekKey={weekKey} showHistoryLink={false} variant="page" />
        </PremiumGate>
      </div>
    </div>
  );
}
